import { FormModel, FormProp } from '@pebula/nform';

@FormModel()
export class InspectorModel {
  @FormProp({
    required: true,
    vType: 'radio',
    ordinal: 0,
    defaultValue: 'Swift Forwarding',
  })
  fileType: string;

  @FormProp({
    vType: 'entitySelectAutoComplete',
    label: 'Partner / Client',
    required: true,
    data: {
      autoLoadInitial: true,
      entity: 'PartnersAndClients',
    },
  })
  partnerOrClient: string;

  @FormProp({
    vType: 'text',
    label: 'File name',
    required: true,
  })
  fileName: string;

  @FormProp({
    vType: 'text',
    label: 'Security ISIN',
  })
  isin: string;

  @FormProp({
    vType: 'select',
    label: 'Date range',
    defaultValue: 1,
    data: {
      options: [
        { value: 0, label: 'last 3 business days' },
        { value: 1, label: 'last 24 hours' },
        { value: 2, label: 'last 12 hours' },
        { value: 3, label: 'last 6 hours' },
        { value: 4, label: 'last hour' },
      ],
    },
  })
  dateRange: number;

  @FormProp({
    vType: 'number',
    label: 'Number of units',
  })
  units: number;

  @FormProp({
    vType: 'text',
    label: 'BIC',
  })
  bic: string;
}
